import * as mutationType from "../mutation_types";
import { getInstance } from "../../auth";
import enums from "@/helpers/enums";

const state = {
  profile: {},
  id: ""
};

const getters = {
  profile: state => state.profile || {},
  settings: (state, getters) => getters.profile.settings || {},
  id: state => state.id,
  direct_manager: (state, getters) => {
    if (getters.profile.directManagerId) {
      return {
        fullName: getters.profile.directManagerName,
        id: getters.profile.directManagerId,
        avatarUrl: getters.profile.directManagerAvatarUrl
      };
    }
    return null;
  },
  is_admin: (state, getters) =>
    getters.profile.systemRoleId == enums.systemRoleTypes.ADMIN,
  is_manager: (state, getters) =>
    getters.profile.systemRoleId == enums.systemRoleTypes.MANAGER
};

const actions = {
  getProfile({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/profile")
        .then(res => {
          commit(mutationType.SET_PROFILE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveProfile({ commit }, profile) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/profile", profile)
        .then(res => {
          profile.id = res.data;
          commit(mutationType.SET_PROFILE, profile);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveProfileNotifications({ commit }, notifications) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/profile/notifications", notifications)
        .then(res => {
          commit(mutationType.SET_PROFILE_NOTIFICATIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  saveNewPassword({}, profile) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/profile/password", profile)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  uploadAvatar({ commit }, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("file", file.file);
      this._vm.$http
        .post("/api/profile/avatar", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          commit(mutationType.SET_PROFILE_AVATAR, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReportFavorite({ commit }, report) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/profile/reports/${report.reportId}/${report.isFavorite}`)
        .then(() => {
          commit(mutationType.SET_PROFILE_REPORT_FAVORITE, report);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getSettings({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/settings")
        .then(res => {
          commit(mutationType.SET_PROFILE_SETTINGS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_PROFILE](state, profile) {
    state.profile = profile;
  },
  [mutationType.SET_PROFILE_AVATAR](state, url) {
    let authService = getInstance();
    authService.user.picture = url;
    state.profile.avatarUrl = url;
  },
  [mutationType.SET_PROFILE_NOTIFICATIONS](state, list) {
    state.profile.notifications = list;
  },
  [mutationType.SET_PROFILE_REPORT_FAVORITE](state, report) {
    var index = state.profile.favoriteReportIds.findIndex(
      x => x == report.reportId
    );
    if (report.isFavorite) {
      if (index < 0) {
        state.profile.favoriteReportIds.push(report.reportId);
      }
    } else {
      if (index >= 0) {
        state.profile.favoriteReportIds.splice(index, 1);
      }
    }
  },
  [mutationType.SET_PROFILE_SETTINGS](state, settings) {
    state.profile.settings = settings;
  },
  [mutationType.SET_PROFILE_SETTINGS_CORE_VALUES](state, coreValues) {
    state.profile.settings.coreValues = coreValues;
  },
  [mutationType.SET_PROFILE_SETTINGS_MISSION_STATEMENT](
    state,
    missionStatement
  ) {
    state.profile.settings.missionStatement = missionStatement.missionStatement;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
